import { ApolloQueryResult, gql } from '@apollo/client'

import { client } from '../client'
import { Enum } from '../../types/enum';


const GET_CAR_COMPANIES_QUERY = gql`
query Query {
    getCarCompanies {
        id
        name
    }
}
`

interface GetCarCompaniesData {
  getCarCompanies: Enum[]
}


export const getCarCompanies = async (): Promise<ApolloQueryResult<GetCarCompaniesData>> => {
  return await client.query<GetCarCompaniesData, any>({ query: GET_CAR_COMPANIES_QUERY })
}
